// extracted by mini-css-extract-plugin
export default {"container":"OurWork_container__rer9w","item":"OurWork_item__UA8Yu","card":"OurWork_card__ukSj1","long":"OurWork_long__hApKn","yellow":"OurWork_yellow__qNwu1"};